<template>
  <div class="container">
    <h2>{{ page.Title }}</h2>
    <div v-if="page.Content" v-html="page.Content"></div>
    <div class="row">
      <div class="col-md-6">
        <!-- education_place -->
        <DoSelect
          v-model="page.Questions[0].Value"
          :value="page.Questions[0].Value"
          :id="page.Questions[0].QID"
          :config="page.Questions[0].Config"
          :options="page.Questions[0].Options"
          @getNewData="educationPlaceSelected"
        />
      </div>
      <div class="col-md-6">
        <!-- education_no_place -->
        <doInput
          v-if="page.Questions[0].Value === 1"
          v-model="page.Questions[1].Value"
          :value="page.Questions[1].Value"
          :id="page.Questions[1].QID"
          :config="page.Questions[1].Config"
        />
      </div>
      <!-- education_campus -->
      <!-- <div class="col-md-6">
        <DoSelect
          v-if="
            page.Questions[5].Options.length && page.Questions[0].Value !== 1
          "
          v-model="page.Questions[5].Value"
          :value="page.Questions[5].Value"
          :id="page.Questions[5].QID"
          :config="page.Questions[5].Config"
          :options="page.Questions[5].Options"
        />
      </div> -->
      <!-- education_no_campus -->
      <!-- <div class="col-md-6">
        
        <doInput
          v-if="page.Questions[5].Value === 1"
          v-model="page.Questions[6].Value"
          :value="page.Questions[6].Value"
          :id="page.Questions[6].QID"
          :config="page.Questions[6].Config"
        />
      </div> -->
      <div class="col-md-6">
        <!-- education_direction -->
        <DoSelect
          v-if="
            page.Questions[2].Options.length && page.Questions[0].Value !== 1
          "
          v-model="page.Questions[2].Value"
          :value="page.Questions[2].Value"
          :id="page.Questions[2].QID"
          :config="page.Questions[2].Config"
          :options="page.Questions[2].Options"
        />
      </div>
      <div class="col-md-6">
        <!-- education_no_direction -->
        <doInput
          v-if="page.Questions[0].Value === 1 || page.Questions[2].Value === 1"
          v-model="page.Questions[3].Value"
          :value="page.Questions[3].Value"
          :id="page.Questions[3].QID"
          :config="page.Questions[3].Config"
        />
      </div>
      <div class="col-md-6">
        <!-- education_date -->
        <DoDate
          v-model="page.Questions[4].Value"
          :value="page.Questions[4].Value"
          :id="page.Questions[4].QID"
          :config="page.Questions[4].Config"
        />
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    methods: {
      educationPlaceSelected() {
        this.$store.state.spinner = true;
        // RESET education_no_place, education_direction, education_no_direction, education_campus & education_no_campus
        this.page.Questions[1].Value = '';
        this.page.Questions[2].Value = '';
        this.page.Questions[3].Value = '';

        // Get new options
        const payload = {
          data: {
            education_place: this.page.Questions[0].Value,
            forStudents: this.$store.state.newData[0].Questions[0].Value == 3,
          },
          endpoint: '/data/GetEducationDetails',
          component: this.page.Component,
        };
        this.$store.dispatch('getSelectOptions', payload);
      },
    },
    mounted() {
      this.$store.state.spinner = true;
      const payload = {
        data: {
          forStudents: false,
        },
        endpoint: '/data/GetEducationPlaces',
        component: this.page.Component,
      };
      this.$store.dispatch('getSelectOptions', payload);
    },
  };
</script>

